import React from 'react';
import CampaignTabContainer from './CampaignTabContainer';

function Campaign() {
    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between">
                <h1>
                    <i className="bi bi-megaphone"></i> Campaigns
                </h1>
            </div>
            <CampaignTabContainer />
        </div>
    );
}

export default Campaign;
